<script>
import SideMenuItem from '../side-menu-item';
import Vue          from 'vue';

export default {
  name  : 'side-menu-item-custom',
  mixins: [SideMenuItem],
  // カスタムメニューアイテムコンポーネント作成ヘルパ
  make  : function(item) {
    return Vue.extend({
      mixins: [this],
      data  : function() {
        return {
          label    : item.label,
          link     : item.link,
          external : item.external,
          analytics: item.analytics || this.$parent.analytics,
        };
      },
    });
  },
};
</script>
